import React from 'react';

/*
 * ТЗ V5 №18: режим жизненного цикла правила.
 *
 * Настраиваемый цикл (подтверждение начала и завершения, другое правило как
 * условие завершения, зоны начала и конца) на backend ещё не включён: нет
 * …/lifecycle в рабочем API. Поэтому режим виден, но выбрать его нельзя, и
 * форма не отправляет никаких новых полей — правило работает по прежнему
 * алгоритму с текущими длительностью, разрывом, расписанием и повторами.
 */
const RuleLifecycleField = ({ idPrefix = 'vio' }) => (
  <fieldset className="vio-rule-lifecycle">
    <legend className="vio-drawer-section-title">Жизненный цикл</legend>
    <label className="vio-zone-scope-option">
      <input type="radio" name={`${idPrefix}-lifecycle`} value="legacy" checked readOnly />
      <span>
        <strong>Стандартный</strong>
      </span>
    </label>
    <label className="vio-zone-scope-option">
      <input type="radio" name={`${idPrefix}-lifecycle`} value="custom" checked={false} disabled readOnly />
      <span>
        <strong>Настраиваемый</strong>
        <span className="vio-field-hint">Пока не включено</span>
      </span>
    </label>
  </fieldset>
);

export default RuleLifecycleField;
